import React, { useState } from "react"
import * as layouts from "layouts"
import * as caching from "brandguide/cache"
import * as brandguide from "brandguide"
import * as apps from "brandguide/build/application"
import * as uuid from "uuid"

interface props extends layouts.containers.ContainerProps {
	onChange(step: number, data: brandguide.api.GuideApplication | undefined): void
}

export function Display(props: props): JSX.Element {
	const { onChange, ...rest } = props
	const _guide = caching.useGuide()

	const [data, setData] = useState(brandguide.api.zeros.guide.guideApplicationZero(_guide.guide?.application))

	const items = data.items || []

	const hasTwoRowsItems = items.length >= brandguide.build.layouts.dualViewItemsCnt

	const ImageComponent = (item: brandguide.api.ApplicationObject) => (
		<apps.layouts.Image
			item={item}
			onDelete={() => setData({ ...data, items: items.filter((i) => i.id !== item.id) })}
			height={hasTwoRowsItems ? "150px" : "250px"}
			width={hasTwoRowsItems ? "150px" : "250px"}
		/>
	)
	const itemsView = brandguide.build.layouts.itemsToView(ImageComponent, items)

	return (
		<layouts.Flex {...rest}>
			<layouts.Flex
				flex="1"
				flexDirection="row"
				background={layouts.theme.colors.white}
				border={layouts.theme.borders.grey.dark50alpha}
				boxShadow={layouts.theme.boxshadow.black.wide}
			>
				<layouts.Flex flex="1" flexDirection="column" py="40px" className="panel">
					<brandguide.build.layouts.SectionStepTitle title="Application" Help={<apps.helps.Modal />} />
					<layouts.Flex flex="1">
						<brandguide.build.layouts.SectionStepContainer desc="Please upload examples of ads, flyers, signage, etc, that show your brand in the real world.">
							<layouts.Flex flexDirection="column" flex="1" my="24px">
								{items.length === 0 && (
									<brandguide.build.dropwells.images.Dropwell
										onChange={(fs) =>
											setData({
												...data,
												items: [
													...items,
													...fs.map((i) =>
														brandguide.api.zeros.application.objectZero({
															id: uuid.v4(),
															thumbnail_contentdigest: i.thumbnail_contentdigest,
															contentdigest: i.contentdigest,
														}),
													),
												],
											})
										}
									/>
								)}
								{items.length > 0 && (
									<apps.Carousel my="10px" autoscrollright>
										<layouts.Flex gridGap="5px">
											{itemsView}
											<layouts.Flex height={hasTwoRowsItems ? "300px" : "250px"} width="250px">
												<brandguide.build.dropwells.images.Dropwell
													onChange={(fs) =>
														setData({
															...data,
															items: [
																...items,
																...fs.map((i) =>
																	brandguide.api.zeros.application.objectZero({
																		id: uuid.v4(),
																		thumbnail_contentdigest: i.thumbnail_contentdigest,
																		contentdigest: i.contentdigest,
																	}),
																),
															],
														})
													}
												/>
											</layouts.Flex>
										</layouts.Flex>
									</apps.Carousel>
								)}
							</layouts.Flex>

							<apps.Explanation
								val={data.descriptions?.upload || ""}
								placeholder="Add further explanation of logo usage here."
								onChange={(text) => {
									setData({
										...data,
										descriptions: brandguide.api.zeros.application.descZero({ ...data.descriptions, upload: text }),
									})
								}}
							/>
							<brandguide.build.layouts.NextStepsNav
								onNext={() => onChange(apps.Steps.RESULT, data)}
								disabled={!brandguide.validations.application.valid.upload(data)}
							/>
							<apps.Progress activeStep={apps.Steps.UPLOAD} steps={apps.layouts.steps} />
						</brandguide.build.layouts.SectionStepContainer>
						<apps.Guidelines activPage="application" />
					</layouts.Flex>
				</layouts.Flex>
			</layouts.Flex>
		</layouts.Flex>
	)
}

Display.defaultProps = {
	flex: "1",
}

export default Display
